import { useRef, useState } from 'react';
// material
import { Avatar, Box, Divider, IconButton } from '@mui/material';
import FaceTwoToneIcon from '@mui/icons-material/FaceTwoTone';
// components
import { useIntl } from 'react-intl';
import { useAuth } from 'hook/useAuth';
import MenuPopover from 'components/Menu/MenuPopover';
import { navbarIconButton } from 'components/Navbars/PortalNavbar/styles';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';

export default function AccountPopover() {
  const { formatMessage: msg } = useIntl();
  const anchorRef = useRef(null);
  const { currentUser, logout } = useAuth();

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const onLogout = () => {
    logout();
  };

  return (
    <>
      <IconButton ref={anchorRef} onClick={handleOpen} sx={navbarIconButton}>
        <Avatar style={{ backgroundColor: 'transparent' }}>
          <FaceTwoToneIcon style={{ width: '1.3em', height: '1.3em' }} />
        </Avatar>
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <MDTypography variant="body2" noWrap>
            {currentUser?.user?.login === 'user'
              ? 'SuperAdmin'
              : `${currentUser?.user?.firstName} ${currentUser?.user?.lastName}`}
          </MDTypography>
          <MDTypography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {currentUser?.user?.login}
          </MDTypography>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Box sx={{ p: 2, pt: 1.5 }}>
          <MDButton
            aria-label={msg({ id: 'action.account.display' })}
            fullWidth
            color="primary"
            variant="outlined"
            onClick={onLogout}
          >
            {msg({ id: 'action.logout' })}
          </MDButton>
        </Box>
      </MenuPopover>
    </>
  );
}
